angular.module("autoSdd.components",[])
.component("autoSdd",{
    templateUrl: 'ng/components/riepilogoEControllo/autSDD/autoSdd.view.html',
    bindings:{
        model:'=',
        riUserG:'<',
        verifica:'=',
        readOnly:'<',
        preventivo:'<'
    },
    controller: AutorizzazioneSddController,
    controllerAs: 'autSddCtrl'
})

function AutorizzazioneSddController(
    $typeDomainService,
    $timeout,
    $financialApiService,
    $configService
){
    var self = this;

    self.$onInit = function(){
        self.supportModel={
            tempIban:"",
            nameBank:"",
            listaIban: [],
            listaBanche:[]

        }
        listOfIban();
        listaBanche();
        $timeout(function(){
            $('[data-toggle="tooltip3"]').tooltip();
        },500)
    }

    self.modifyIban = function(){
        self.inputIban= !self.inputIban;
        jQuery('[data-toggle="tooltip1"]').tooltip('hide');
        jQuery('[data-toggle="tooltip3"]').tooltip('hide');
    }

    self.saveIban = function(){
        self.model.iban= self.supportModel.tempIban;
        self.model.banca.name= self.supportModel.nameBank;
        self.inputIban=false;
        callCheckIban(self.model.iban);
        jQuery('[data-toggle="tooltip1"]').tooltip('hide');
    }

    var listOfIban = function(){
        
		$typeDomainService.getListIban(self.riUserG, true)
			.then(function (listAppNsilIban) {
				if (listAppNsilIban && listAppNsilIban.length > 0) {
					listAppNsilIban.forEach(function (el) {
						self.supportModel.listaIban.push(el.iban);
					});
				}
			})
			.catch(function (err) {
				console.log(err);
				self.dropdown.listaIban = [];
			})
    }

    var listaBanche = function(){
        
		$typeDomainService.getDomainSet('RI_DROPDOWN_DOMAINS', 'BANKS')
			.then(function (response) {
				self.supportModel.listaBanche = response.domainList;
                if(self.model.iban){
                    var iban = self.model.iban.toUpperCase().trim().slice(0, 27);
                    var code = iban.slice(5, 10);
                }
				var bank = self.supportModel.listaBanche.find(function (el) {
					return el.value == code;
				});
                self.model.banca.name = bank && bank.name;

			})
		
    }

    self.getListaIban = function (search, ibanList) {
			if (ibanList.length) {
				var newIbanList = ibanList.slice();
				if (search && newIbanList.indexOf(search) === -1) {
					newIbanList.unshift(search);
				}
				return newIbanList; 
			}
	}

    self.selectBank = function () {
			self.warningsIban = false;
			if (self.supportModel.tempIban) {
				var iban = self.supportModel.tempIban.toUpperCase().trim().slice(0, 27);
				if (checkiban(iban)) {
					self.warningsIban = false;
					var code = iban.slice(5, 10);
					var bank = self.supportModel.listaBanche.find(function (el) {
						return el.value == code;
					});
                    self.supportModel.nameBank = bank && bank.name;
				} else {
					self.warningsIban = true;
					self.supportModel.nameBank = '';
					return;
				}
            }else{
                self.supportModel.nameBank = '';
            }
    }

    self.check = function(el){
        el.selected = !el.selected;
        if(el.selected){
            el.ndg= $configService.getUser().ndg;
            el.identifier= $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        }else{
            el.ndg= "";
            el.identifier= "";
            el.dataConferma = "";
        }
    }

    var callCheckIban = function(iban){
        $financialApiService
            .checkIban(iban)
            .then(function (ibanResponse) {
              console.log('product is: ', ibanResponse);
            })
            .catch(function (err) {
              console.error("Errore: ", err);
            })
    }
}